import { render, staticRenderFns } from "./perdaManag.vue?vue&type=template&id=1aa09b20&scoped=true&"
import script from "./perdaManag.vue?vue&type=script&lang=js&"
export * from "./perdaManag.vue?vue&type=script&lang=js&"
import style0 from "./perdaManag.vue?vue&type=style&index=0&id=1aa09b20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa09b20",
  null
  
)

export default component.exports